import React from "react";

const DropdownHospitalListing = ({
	label,
	labelFor,
	options,
	disabled,
	setSelectedHospital,
	selectedHospital,
	setLocationType,
}) => {
	const handleSelectChange = (event) => {
		const selectedValue = event.target.value;
		const selectedOption = options.find(
			(option) =>
				option.hospital_id === selectedValue ||
				option.clinic_id === selectedValue
		);

		setSelectedHospital(selectedValue);
		setLocationType(
			selectedOption
				? selectedOption.hospital_id
					? "hospital"
					: "clinic"
				: null
		);
	};

	// Sort options, hospital A-Z then clinic A-Z
	const sortedOptions = [...(options || [])].sort((a, b) => {
		// Determine type: hospital first (0), clinic second (1)
		const typeA = a.hospital_name ? 0 : 1;
		const typeB = b.hospital_name ? 0 : 1;

		if (typeA !== typeB) {
			return typeA - typeB; // hospital first, then clinic
		}

		// If same type, compare alphabetically by the correct name
		const nameA = (a.hospital_name || a.clinic_name || "").toLowerCase();
		const nameB = (b.hospital_name || b.clinic_name || "").toLowerCase();
		return nameA.localeCompare(nameB);
	});

	return (
		<div style={{ position: "relative" }}>
			<div style={{ position: "relative", zIndex: "2" }}>
				<select
					className="form-select form-select-lg"
					aria-label=".form-select-lg"
					id={labelFor}
					value={selectedHospital}
					onChange={handleSelectChange}
					style={{
						fontWeight: selectedHospital ? "700" : "300",
						color: selectedHospital ? "black" : "#A7A7A7",
					}}
					disabled={disabled}
				>
					<option value="" disabled>
						Select hospital/clinic
					</option>
					{sortedOptions.map((option) => (
						<option
							key={option.hospital_id || option.clinic_id}
							value={option.hospital_id || option.clinic_id}
						>
							{option.hospital_name || option.clinic_name}
						</option>
					))}
				</select>
			</div>
			<img
				src="./img/icon/dropdown-icon.png"
				alt=""
				className="dropdown-icon-style"
			/>
		</div>
	);
};

export default DropdownHospitalListing;
